/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AutobookingView {
  categoryId?: string;
  serviceId?: string;
}

export interface GarageAutobookingServiceStatus {
  available?: boolean;
}

export interface GarageCommentStatistics {
  price?: MinMaxAvg;
  service?: MinMaxAvg;
  time?: MinMaxAvg;
  total?: MinMaxAvg;
  totalItems?: number;
}

export interface GarageDriverReminderPayload {
  email?: string;
  /**
   * @min 0
   * @exclusiveMin true
   */
  garageId?: number;
  /**
   * @minLength 1
   * @maxLength 50
   */
  topic?: string;
}

export interface GarageGooglePlaceReview {
  author?: string;
  createdAt?: string;
  description?: string;
  rating?: number;
}

export interface GarageIdentifier {
  id?: number;
  slug?: string;
  slugCity?: string;
  slugHistory?: SlugHistory | null;
}

export interface GarageSlotsOverview {
  /** @format date-time */
  date?: string;
  slots?: SlotOverview[];
}

export interface LegacyApiBadRequestError {
  detail?: string | null;
  errors?: LegacyApiValidationError[];
  title?: string | null;
  type?: string | null;
}

export interface LegacyApiValidationError {
  propertyPath?: string | null;
  title?: string | null;
  type?: string | null;
}

export interface LegacyService {
  category?: ServiceCategory;
  description?: string | null;
  id?: string | number;
  name?: string | null;
  popular?: boolean;
  price?: Price;
  priceCategoryId?: number | null;
  priceServiceId?: number | null;
  seoServiceId?: number | null;
  surcharges?: LegacyService[];
  virtual?: boolean;
  zilo?: ZiloService | null;
}

export interface MinMaxAvg {
  /** @format float */
  avg?: number;
  /** @format float */
  max?: number;
  /** @format float */
  min?: number;
}

export interface Price {
  /** @format float */
  priceFrom?: number | null;
  /** @format float */
  priceTo?: number | null;
}

export interface PriceCategoryView {
  id?: string;
  name?: string;
  position?: number;
  priceList?: PriceElementView[];
  shortName?: string;
}

export interface PriceElementFlagsView {
  popular?: boolean;
  surcharge?: boolean;
  virtual?: boolean;
}

export interface PriceElementView {
  autobooking?: AutobookingView;
  description?: string | null;
  flags?: PriceElementFlagsView;
  id?: string | number;
  name?: string;
  price?: PriceView;
  score?: number;
  surcharges?: SurchargeElementView[];
}

export interface PriceView {
  /** @format float */
  priceFrom?: number | null;
  /** @format float */
  priceTo?: number | null;
}

export interface PriceView2 {
  /** @format float */
  priceFrom?: number | null;
  /** @format float */
  priceTo?: number | null;
}

export interface ServiceCategory {
  id?: string;
  name?: string;
  position?: number;
  shortName?: string;
}

export interface SlotOverview {
  availableWorkspaces?: WorkspaceOverview[];
  date?: string;
  duration?: number;
  status?: string;
}

export interface SlugHistory {
  slug?: string;
}

export interface SurchargeElementView {
  description?: string | null;
  id?: number | null;
  name?: string;
  popular?: boolean;
  price?: PriceView2;
  virtual?: boolean;
  zilo?: ZiloService2 | null;
}

export interface VirtualServiceCategory {
  categoryName?: string | null;
  /** @format uuid */
  id?: string | null;
  pills?: string[];
  priceName?: string | null;
  requiredSeoServiceSlug?: string | null;
  requiredSeoServiceSlugId?: number | null;
}

export interface WorkspaceOverview {
  id?: string;
  type?: string;
}

export interface ZiloService {
  categoryId?: string | null;
  serviceId?: string | null;
}

export interface ZiloService2 {
  categoryId?: string | null;
  serviceId?: string | null;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title dobrymechanik-app
 * @version 1.0.0
 *
 * Awesome app!
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @name PostAppGarageCreateDriverReminder
     * @request POST:/api/free-garage/create-driver-reminder
     * @secure
     */
    postAppGarageCreateDriverReminder: (data: GarageDriverReminderPayload, params: RequestParams = {}) =>
      this.request<void, LegacyApiBadRequestError>({
        path: `/api/free-garage/create-driver-reminder`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAppGarageCommentStatistics
     * @request GET:/api/garage/{garageId}/comment-statistics
     * @secure
     */
    getAppGarageCommentStatistics: (garageId: string, params: RequestParams = {}) =>
      this.request<GarageCommentStatistics, any>({
        path: `/api/garage/${garageId}/comment-statistics`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAppGarageGooglePlaceReview
     * @request GET:/api/garage/{garageId}/google-place-review
     * @secure
     */
    getAppGarageGooglePlaceReview: (
      garageId: string,
      query?: {
        limit?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<GarageGooglePlaceReview[], any>({
        path: `/api/garage/${garageId}/google-place-review`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @name GetAppGaragePriceList
 * @summary List the services with price for specific garage
Show only supported services
 * @request GET:/api/garage/{garageId}/price-list
 * @secure
 */
    getAppGaragePriceList: (garageId: string, params: RequestParams = {}) =>
      this.request<LegacyService[], any>({
        path: `/api/garage/${garageId}/price-list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAppGaragePriceListWithCategories
     * @summary List the categories with services for specific garage
     * @request GET:/api/garage/{garageId}/price-list-with-categories
     * @secure
     */
    getAppGaragePriceListWithCategories: (
      garageId: string,
      query?: {
        /** Service category identifier */
        categoryId?: any;
        /** Search phrase for example: olej */
        search?: any;
        /** Mark most popular services for given seo service id */
        seoServiceId?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<PriceCategoryView[], any>({
        path: `/api/garage/${garageId}/price-list-with-categories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAppGarageSeoSchema
     * @summary Returns JSON seo schema for business card
     * @request GET:/api/garage/{garageId}/seo-schema
     * @secure
     */
    getAppGarageSeoSchema: (garageId: string, params: RequestParams = {}) =>
      this.request<object, any>({
        path: `/api/garage/${garageId}/seo-schema`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAppGarageSlotsForService
     * @request GET:/api/garage/{garageId}/slots/{serviceId}
     * @secure
     */
    getAppGarageSlotsForService: (garageId: string, serviceId: string, params: RequestParams = {}) =>
      this.request<GarageSlotsOverview[], any>({
        path: `/api/garage/${garageId}/slots/${serviceId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @name GetAppGarageVirtualServiceCategoriesList
 * @summary List the virtual service categories
Shows only if garage has available repairs and faults service
 * @request GET:/api/garage/{garageId}/virtual-categories
 * @secure
 */
    getAppGarageVirtualServiceCategoriesList: (garageId: string, params: RequestParams = {}) =>
      this.request<VirtualServiceCategory[], any>({
        path: `/api/garage/${garageId}/virtual-categories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @name GetAppGarageIdByUrl
 * @summary Get garage identifier by garage url/slug
Example dm-motors-mechanika-pojazdowa.html -> 20333
 * @request GET:/api/garages/id_by_url/{url}
 * @secure
 */
    getAppGarageIdByUrl: (url: string, params: RequestParams = {}) =>
      this.request<GarageIdentifier, any>({
        path: `/api/garages/id_by_url/${url}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAppGarageAutobookingServiceAvailability
     * @request GET:/api/garages/{garageId}/autobooking/{serviceId}/availability
     * @secure
     */
    getAppGarageAutobookingServiceAvailability: (garageId: string, serviceId: string, params: RequestParams = {}) =>
      this.request<GarageAutobookingServiceStatus, any>({
        path: `/api/garages/${garageId}/autobooking/${serviceId}/availability`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
